import { jsx as _jsx } from "preact/jsx-runtime";
import styles from './Image.module.scss';
export default function Image({ children, src }) {
    return (_jsx("img", Object.assign({ alt: "quiz image", className: styles.image, src: src, loading: "lazy", width: "200", height: "150" }, { children: children }), void 0));
}
